export function Loader() {
	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
			<div className="flex items-center space-x-2">
				<span className="sr-only">Loading...</span>
				<div className="h-4 w-4 bg-primary rounded-full animate-bounce [animation-delay:-0.3s]"></div>
				<div className="h-4 w-4 bg-primary rounded-full animate-bounce [animation-delay:-0.15s]"></div>
				<div className="h-4 w-4 bg-primary rounded-full animate-bounce"></div>
			</div>
		</div>
	);
}
